import { observer } from 'mobx-react-lite'
import classnames from 'classnames'
import { EnumSpinnerLoaderPlacement, SpinnerLoader, Tabs, Typography } from 'shared/ui'
import { useResultsContext } from 'pages/conversations/pages/search/ui/Results/context/resultsContext'
import { SectionAllContactsList } from 'pages/conversations/pages/search/ui/Results/ui/SectionAllContacts/ui/SectionAllContactsList'
import styles from './styles.module.scss'

export const SectionAllContacts = observer(() => {
  const { resultsContactsStore } = useResultsContext()
  const { tabs, activeTab, setActiveTab, activeContactsByIntegration, count, loading } =
    resultsContactsStore

  const renderContent = () => {
    if (!activeContactsByIntegration) return null

    return <SectionAllContactsList activeIntegration={activeContactsByIntegration} />
  }

  if (!count && loading) {
    return (
      <div className={styles.loading}>
        <SpinnerLoader
          ariaLabel={'SectionAllContactsList'}
          size={20}
          placement={EnumSpinnerLoaderPlacement.Top}
        />
      </div>
    )
  }

  if (!count) {
    return (
      <div className={styles.wrap}>
        <Typography
          tag={'div'}
          variant={'body-sm-regular'}
          ariaLabel={'empty'}
          className={classnames(styles.empty, styles['empty--all'])}
        >
          No contacts found
        </Typography>
      </div>
    )
  }

  return (
    <div
      className={classnames(styles.wrap, {
        [styles.hideTabs]: tabs.length === 1,
      })}
    >
      {tabs.length > 1 && (
        <div className={styles.tabs}>
          <Tabs
            tabs={tabs}
            activeTabKey={activeTab}
            variant={'simpleWithoutBorder'}
            countVariant={'white'}
            handleSelectTab={(tab) => {
              setActiveTab(tab.key)
            }}
            gap={8}
          />
        </div>
      )}

      {renderContent()}
    </div>
  )
})
